import * as React from 'react';
import RcUpload from 'rc-upload';
import classNames from 'classnames';
import UploadList from './UploadList';
import { UploadProps, } from './interface';
import { T, fileToObject, getFileItem, removeFileItem } from './utils';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale/default';
import { ConfigConsumer } from '../config-provider';
import devWarning from '../_util/devWarning';
export { UploadProps };
let Upload = /** @class */ (() => {
    class Upload extends React.Component {
        constructor(props) {
            super(props);
            this.saveUpload = (node) => {
                this.upload = node;
            };
            this.onStart = (file) => {
                const { fileList } = this.state;
                const targetItem = fileToObject(file);
                targetItem.status = 'uploading';
                const nextFileList = fileList.concat();
                const fileIndex = nextFileList.findIndex(({ uid }) => uid === targetItem.uid);
                if (fileIndex === -1) {
                    nextFileList.push(targetItem);
                }
                else {
                    nextFileList[fileIndex] = targetItem;
                }
                this.onChange({
                    file: targetItem,
                    fileList: nextFileList,
                });
            };
            this.onSuccess = (response, file, xhr) => {
                this.clearProgressTimer();
                try {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }
                }
                catch (e) {
                    /* do nothing */
                }
                const { fileList } = this.state;
                const targetItem = getFileItem(file, fileList);
                // removed
                if (!targetItem) {
                    return;
                }
                targetItem.status = 'done';
                targetItem.response = response;
                targetItem.xhr = xhr;
                this.onChange({
                    file: Object.assign({}, targetItem),
                    fileList,
                });
            };
            this.onProgress = (e, file) => {
                const { fileList } = this.state;
                const targetItem = getFileItem(file, fileList);
                // removed
                if (!targetItem) {
                    return;
                }
                targetItem.percent = e.percent;
                this.onChange({
                    event: e,
                    file: Object.assign({}, targetItem),
                    fileList,
                });
            };
            this.onError = (error, response, file) => {
                this.clearProgressTimer();
                const { fileList } = this.state;
                const targetItem = getFileItem(file, fileList);
                // removed
                if (!targetItem) {
                    return;
                }
                targetItem.error = error;
                targetItem.response = response;
                targetItem.status = 'error';
                this.onChange({
                    file: Object.assign({}, targetItem),
                    fileList,
                });
            };
            this.handleRemove = (file) => {
                const { onRemove } = this.props;
                const { fileList } = this.state;
                Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(ret => {
                    // Prevent removing file
                    if (ret === false) {
                        return;
                    }
                    const removedFileList = removeFileItem(file, fileList);
                    if (removedFileList) {
                        file.status = 'removed';
                        if (this.upload) {
                            this.upload.abort(file);
                        }
                        this.onChange({
                            file,
                            fileList: removedFileList,
                        });
                    }
                });
            };
            this.onChange = (info) => {
                if (!('fileList' in this.props)) {
                    this.setState({ fileList: info.fileList });
                }
                const { onChange } = this.props;
                if (onChange) {
                    onChange(Object.assign(Object.assign({}, info), { fileList: [...info.fileList] }));
                }
            };
            this.onFileDrop = (e) => {
                this.setState({
                    dragState: e.type,
                });
            };
            this.beforeUpload = (file, fileList) => {
                const { beforeUpload } = this.props;
                const { fileList: stateFileList } = this.state;
                if (!beforeUpload) {
                    return true;
                }
                const result = beforeUpload(file, fileList);
                if (result === false) {
                    // Get unique file list
                    const uniqueList = [];
                    stateFileList.concat(fileList.map(fileToObject)).forEach(f => {
                        if (uniqueList.every(uf => uf.uid !== f.uid)) {
                            uniqueList.push(f);
                        }
                    });
                    this.onChange({
                        file,
                        fileList: uniqueList,
                    });
                    return false;
                }
                if (result && result.then) {
                    return result;
                }
                return true;
            };
            this.renderUploadList = (locale) => {
                const { showUploadList, listType, onPreview, onDownload, previewFile, disabled, locale: propLocale, iconRender, isImageUrl, progress, } = this.props;
                const { showRemoveIcon, showPreviewIcon, showDownloadIcon, removeIcon, downloadIcon, } = showUploadList;
                const { fileList } = this.state;
                return (<UploadList listType={listType} items={fileList} previewFile={previewFile} onPreview={onPreview} onDownload={onDownload} onRemove={this.handleRemove} showRemoveIcon={!disabled && showRemoveIcon} showPreviewIcon={showPreviewIcon} showDownloadIcon={showDownloadIcon} removeIcon={removeIcon} downloadIcon={downloadIcon} iconRender={iconRender} locale={Object.assign(Object.assign({}, locale), propLocale)} isImageUrl={isImageUrl} progress={progress}/>);
            };
            this.renderUpload = ({ getPrefixCls, direction }) => {
                const { prefixCls: customizePrefixCls, className, showUploadList, listType, type, disabled, children, style, } = this.props;
                const { fileList, dragState } = this.state;
                const prefixCls = getPrefixCls('upload', customizePrefixCls);
                const rcUploadProps = Object.assign(Object.assign({ onStart: this.onStart, onError: this.onError, onProgress: this.onProgress, onSuccess: this.onSuccess }, this.props), { prefixCls, beforeUpload: this.beforeUpload });
                delete rcUploadProps.className;
                delete rcUploadProps.style;
                // Remove id to avoid open by label when trigger is hidden
                // !children: https://github.com/ant-design/ant-design/issues/14298
                // disabled: https://github.com/ant-design/ant-design/issues/16478
                //           https://github.com/ant-design/ant-design/issues/24197
                if (!children || disabled) {
                    delete rcUploadProps.id;
                }
                const uploadList = showUploadList ? (<LocaleReceiver componentName="Upload" defaultLocale={defaultLocale.Upload}>
        {this.renderUploadList}
      </LocaleReceiver>) : null;
                if (type === 'drag') {
                    const dragCls = classNames(prefixCls, {
                        [`${prefixCls}-drag`]: true,
                        [`${prefixCls}-drag-uploading`]: fileList.some(file => file.status === 'uploading'),
                        [`${prefixCls}-drag-hover`]: dragState === 'dragover',
                        [`${prefixCls}-disabled`]: disabled,
                        [`${prefixCls}-rtl`]: direction === 'rtl',
                    }, className);
                    return (<span>
          <div className={dragCls} onDrop={this.onFileDrop} onDragOver={this.onFileDrop} onDragLeave={this.onFileDrop} style={style}>
            <RcUpload {...rcUploadProps} ref={this.saveUpload} className={`${prefixCls}-btn`}>
              <div className={`${prefixCls}-drag-container`}>{children}</div>
            </RcUpload>
          </div>
          {uploadList}
        </span>);
                }
                const uploadButtonCls = classNames(prefixCls, {
                    [`${prefixCls}-select`]: true,
                    [`${prefixCls}-select-${listType}`]: true,
                    [`${prefixCls}-disabled`]: disabled,
                    [`${prefixCls}-rtl`]: direction === 'rtl',
                });
                const uploadButton = (<div className={uploadButtonCls} style={children ? undefined : { display: 'none' }}>
        <RcUpload {...rcUploadProps} ref={this.saveUpload}/>
      </div>);
                if (listType === 'picture-card') {
                    return (<span className={classNames(className, `${prefixCls}-picture-card-wrapper`)}>
          {uploadList}
          {uploadButton}
        </span>);
                }
                return (<span className={className}>
        {uploadButton}
        {uploadList}
      </span>);
            };
            this.state = {
                fileList: props.fileList || props.defaultFileList || [],
                dragState: 'drop',
            };
            if (process.env.NODE_ENV !== 'production')
                devWarning('fileList' in props || !('value' in props), 'Upload', '`value` is not a valid prop, do you mean `fileList`?');
        }
        static getDerivedStateFromProps(nextProps) {
            if ('fileList' in nextProps) {
                return {
                    fileList: nextProps.fileList || [],
                };
            }
            return null;
        }
        componentWillUnmount() {
            this.clearProgressTimer();
        }
        clearProgressTimer() {
            clearInterval(this.progressTimer);
        }
        render() {
            return <ConfigConsumer>{this.renderUpload}</ConfigConsumer>;
        }
    }
    Upload.defaultProps = {
        type: 'select',
        multiple: false,
        action: '',
        data: {},
        accept: '',
        beforeUpload: T,
        showUploadList: true,
        listType: 'text',
        className: '',
        disabled: false,
        supportServerRender: true,
    };
    return Upload;
})();
export default Upload;
